// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3d5xb","index":"styles_index__1wL6f"};